import { CollectionResponse } from "@rumble-it/common-lib/types/api/CollectionResponse.interface";
import { Affiliate } from "@rumble-it/common-lib/types/models/Affiliate.interface";
import { axiosInstance } from "../client";
import { MIME_TYPE_FORM_DATA_MULTIPART } from "@rumble-it/common-lib/src/constants/mimeTypes";

export async function fetchAffiliates(): Promise<
  CollectionResponse<Affiliate>
> {
  return axiosInstance
    .get("affiliates", { isRootRequest: true })
    .then((response) => response.data);
}

export async function fetchAffiliateById(id: string): Promise<Affiliate> {
  return axiosInstance
    .get(`affiliates/${id}`, {
      isRootRequest: true,
    })
    .then((response) => response.data);
}

export async function createAffiliate(payload: Partial<Affiliate>) {
  return axiosInstance
    .post("affiliates", payload, { isRootRequest: true })
    .then((response) => response.data);
}

export const importAffiliateExcel = async (file: File): Promise<null> => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance
    .post(`/data-management/import-excel`, formData, {
      headers: { "Content-Type": MIME_TYPE_FORM_DATA_MULTIPART },
    })
    .then((response) => response.data);
};
